import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, Row, Col, Spinner, FormGroup, Form, Input } from "reactstrap";
import Select from 'react-select';

// api
import categoriafiscalizacao_api from "../../../api/categoriafiscalizacao_api.js";
import formulariovistoria_api from "../../../api/formulariovistoria_api.js";

// helpers
import { showMessage } from "../../../helpers/message.js";

export default function CategoriaFiscalizacaoFicha({ item, handleReturn }) {
    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });
    const [showLoading, setshowLoading] = useState(false);
    const [isDisable, set_isDisable] = useState(false);

    const [categoria, set_categoria] = useState(item);

    // Status
    const options_status = [
        { label: "Ativo", value: "Ativo" },
        { label: "Inativo", value: "Inativo" }
    ];
    const [status, set_status] = useState("Ativo");
    const handleChangeStatus = (value) => {
        set_status(value);
        clearErrors("status");
        setValue("status", value, true);
    }

    // Formularios
    const [options_formularios, set_options_formularios] = useState([]);
    const [formularios, set_formularios] = useState([]);

    const loadFormularios = () => {
        formulariovistoria_api.getAll().then(result => {
            if (result.status === 200) {
                set_options_formularios(result.data);
            }
        });
    }

    const handleFormularios = (value) => {
        let _formularios = [];
        if (value) {
            value.forEach(f => _formularios.push(f.formularioVistoria_Id));
        }
        set_formularios(_formularios);
    }

    const loadForm = () => {
        if (categoria) {
            setValue("identificacao", categoria.identificacao);
            set_status(categoria.status);
            setValue("status", categoria.status, true);
            set_formularios(categoria.formularioVistorias_Ids || []);
        } else {
            setValue("status", "Ativo", true);
        }
    }

    useEffect(() => {
        loadFormularios();
        loadForm();
    }, []);

    const Voltar = () => {
        handleReturn();
    }

    const onSubmit = (data) => {
        let json_submit = {
            categoriaFiscalizacao_Id: categoria ? categoria.categoriaFiscalizacao_Id : 0,
            identificacao: data.identificacao,
            status: status,
            formularioVistorias_Ids: formularios
        };

        setshowLoading(true);
        if (json_submit.categoriaFiscalizacao_Id == 0)
            categoriafiscalizacao_api.postCategoria(json_submit).then(result => handleReturnSubmit(result));
        else
            categoriafiscalizacao_api.putCategoria(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                handleReturn();
            });
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="6">
                        <Button color="default" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                    </Col>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <h4 className="titleCard">{categoria ? "Editar Categoria" : "Nova Categoria"}</h4>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row className="align-items-end">
                                        <Col lg="8" md="12" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Identificação</label>
                                                <Input className="form-control"
                                                    autoComplete="off"
                                                    type="text"
                                                    name="identificacao"
                                                    innerRef={register({ required: true })}
                                                    disabled={isDisable}
                                                />
                                                {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col lg="4" md="12" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Status</label>
                                                <Select
                                                    name="status"
                                                    options={options_status}
                                                    getOptionLabel={o => o.label}
                                                    getOptionValue={o => o.value}
                                                    value={options_status.filter(f => f.value === status)}
                                                    onChange={(o) => handleChangeStatus(o.value)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Selecione ]"
                                                    ref={e => register(
                                                        { name: "status" },
                                                        { required: true })
                                                    }
                                                    isDisabled={isDisable}
                                                />
                                                {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>

                                        <Col lg="12" md="12" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Formulários de Fiscalização Vinculados</label>
                                                <Select
                                                    name="formularios"
                                                    options={options_formularios}
                                                    getOptionLabel={o => o.identificacao}
                                                    getOptionValue={o => o.formularioVistoria_Id}
                                                    value={options_formularios.filter(f => formularios.includes(f.formularioVistoria_Id))}
                                                    onChange={(o) => handleFormularios(o)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Selecione ]"
                                                    isMulti={true}
                                                    isDisabled={isDisable}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    {!isDisable &&
                                        <Row>
                                            <Col lg="12" md="12" sm="12" className="text-center">
                                                <Button color="success" type="submit">
                                                    <i className="fas fa-save"></i>  Salvar
                                                </Button>
                                            </Col>
                                        </Row>
                                    }
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}
